// extracted by mini-css-extract-plugin
export var labelWrapper = "_h2-0";